import { format, parseISO, isThisYear } from 'date-fns';

export const formatDateTime = (isoString: string) => {
  const date = parseISO(isoString);

  const time = format(date, 'HH:mm:ss');

  if (isThisYear(date)) {
    return {
      date: format(date, 'MMM dd'),
      time,
    };
  }

  return {
    date: format(date, 'dd/MM/yy'),
    time,
  };
};
